module.exports = __webpack_public_path__ + "static/media/14UNEP9.5316829a.jpg";